module.exports = __webpack_public_path__ + "230aa0cfc6ecf9bf4f5b2222a409c25e.svg";